<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Academic Dashboard</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <!-- <v-row justify="center">
                    <v-col sm="4">
                        <h3>Academic Dashboard</h3>
                    </v-col>
                </v-row> -->
        <v-row justify="center" class="ml-12">
          <v-col sm="3">
            <v-combobox dense rounded v-model="ay" :items="ay_selection_for_dashboard.academic_year_list"
              item-text="Application Status Data" label="Academic Year" outlined></v-combobox>
          </v-col>
          <v-col sm="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
              item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
          </v-col>
          <v-col sm="3">
            <v-btn class="button pt-0 mt-0" @click="generateChartandTable" :loading="fetch_btn_load">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!------------------------------------------------->
    <v-card class="box" v-if="studentList != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Academic Dashboard</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat dense>
        <!-- Academic Dashboard -->
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
      <v-data-table :headers="headers" :items="tableWithTotals" dense class="elevation-1 mytable" :search="search"
        :items-per-page="-1">
      </v-data-table>
    </v-card>
    <!------------------------------------------------->
    <v-card class="box" flat v-if="studentList != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Graphical Representation</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- <v-card-title>Graphical Representation</v-card-title> -->
      <!-- new code  -->
      <v-row dense>
        <v-col cols="12" sm="12" md="2"> </v-col>
        <v-col cols="12" sm="6" md="2">
          <span>
            <v-icon class="dot" style="background-color: #c23531" color="#c23531">mdi-radiobox-blank
            </v-icon>Female</span>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <span>
            <v-icon class="dot" style="background-color: #2f4554" color="#2f4554">mdi-radiobox-blank
            </v-icon>Male</span>
        </v-col>
      </v-row>

      <!-- chart code new -->
      <center>
        <chart auto-resize :options="option1"></chart>
      </center>

      <!-- new code end -->
      <!-- <chart :options="gender_report_graph"></chart> -->
    </v-card>
    <!--------------------------------------------------------------------------->
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboar
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    ay_selection_for_dashboard: "",
    ay: null,
    search: "",
    fetch_btn_load: false,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    studentList: null,
    academic_year_list: null,
    gender_report_graph: {
      color: ["#003366", "#e5323e", "#006699", "#4cabce"],
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["Male", "Female"],
      },
      xAxis: [
        {
          type: "category",
          data: [],
        },
      ],
      yAxis: [
        {
          type: "value",
        },
      ],
      series: [
        {
          data: [],
          type: "bar",
        },
        {
          data: [],
          type: "bar",
        },
      ],
    },
    academic_year_list: null,

    search: "",
    headers: [
      {
        text: "Standard",
        align: "left",
        sortable: false,
        value: "st",
      },
      { text: "Total", value: "total" },
      { text: "Female", value: "fcount" },
      { text: "Male", value: "mcount" },
    ],
    status_list: [
      { name: "Active", id: "0" },
      { name: "Temporary Inactive", id: "1" },
      { name: "Permanent Inactive", id: "2" },
    ],
    status: null,
    // new chart data
    option1: {
      height: "350px",
      width: "500px",
      // color: ["#3398DB"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
          label: {
            show: true,
          },
        },
      },
      toolbox: {
        show: true,
        feature: {
          mark: { show: true },
          magicType: {
            show: true,
            type: ["line", "bar", "stack"],
            title: {
              line: "Switch to Line Chart",
              bar: "Switch to Bar Chart",
              stack: "Switch to Stack Chart",
            },
          },
          restore: { show: true, title: "Restore" },
          saveAsImage: {
            show: true,
            title: "Save As Image",
          },
          dataView: {
            show: true,
            title: "Data View",
            readonly: false,
          },
        },
      },
      calculable: true,
      legend: {
        data: [],
        itemGap: 5,
      },
      grid: {
        top: "12%",
        left: "5%", // change from 1% by shiv
        right: "16%", // change from 10% by shiv
        bottom: " 3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [],
        axisLabel: {
          margin: 15,
          rotate: 35,
        },
        axisTick: {
          alignWithLabel: true,
        },
        name: "Standard",
        nameLocation: "end",
        offset: 10,
      },
      yAxis: {
        type: "value",
        name: "Student Count",
        nameLocation: "end",
        offset: 10,
      },
      series: [
        {
          data: [],
          value: [],
          type: "bar",

          // label: {
          //     show: true,
          //     position: "top",
          //     rotate: 45,
          //     offset: [2, 5],
          // },
          //name:'Direct'
        },
        {
          data: [],
          value: [],
          type: "bar",

          // label: {
          //     show: true,
          //     rotate: 45,
          //     position: "top",
          //     offset: [2, 5],
          // },
          //name:'Direct'
        },
      ],
    },
  }),

  methods: {
    generateChartandTable() {
      this.fetch_btn_load = true;
      const formData = {
        ay: this.ay,
        status: this.status,
      };
      // generateChartandTableNew
      // generateChartandTable
      axios
        .post("/admission/generateChartandTableNew", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.studentList = res.data.studentList;
            console.log(this.studentList);
            this.fetch_btn_load = false;
            // this.gender_report_graph.xAxis[0].data = res.data.series;
            // this.gender_report_graph.series[0].data = res.data.series;
            // show snackbar on success
            //console.log("res.data>>"+res.data)

            // new chart code
            this.option1.series[0].data = res.data.fvalue;
            this.option1.series[1].data = res.data.mvalue;
            this.option1.xAxis.data = res.data.data;
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //close loader
          this.fetch_btn_load = false;
        });
    },

    onLoad() {
      axios
        .post("/admission/academicDashboard")
        .then((res) => {
          if (res.data.msg == "200") {
            this.ay_selection_for_dashboard =
              res.data.ay_selection_for_dashboard;
            this.ay = this.ay_selection_for_dashboard.current_academic_year;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        });
    },
  },
  computed: {
  tableWithTotals() {
    const totalFemale = this.studentList.reduce((sum, item) => sum + (item.fcount || 0), 0);
    const totalMale = this.studentList.reduce((sum, item) => sum + (item.mcount || 0), 0);
    const total = totalFemale + totalMale;

    return [
      ...this.studentList,
      {
        st: 'Total',
        total,
        fcount: totalFemale,
        mcount: totalMale
      }
    ];
  }
},
  mounted() {
    this.onLoad();
  },
};
</script>
<style scoped>
/* shiv css */
.dot {
  height: 25px;
  width: 25px;
  /* background-color: #bbb; */
  border-radius: 50%;
  display: inline-block;
}
</style>
